import {
  DATA_CONNECTOR_SAVE_MY_SQL_DATA_IN_EXTERNAL_DB_BEGIN,
  DATA_CONNECTOR_SAVE_MY_SQL_DATA_IN_EXTERNAL_DB_SUCCESS,
  DATA_CONNECTOR_SAVE_MY_SQL_DATA_IN_EXTERNAL_DB_FAILURE,
  DATA_CONNECTOR_SAVE_MY_SQL_DATA_IN_EXTERNAL_DB_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';

export function saveMySqlDataInExternalDb(args = {}) {
  console.log('🚀 ~ saveMySqlDataInExternalDb ~ args:', args);
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_SAVE_MY_SQL_DATA_IN_EXTERNAL_DB_BEGIN,
    });

    const { projectId, version, dataForSave } = args;
    const header = builderSurfaceJsonContentHeader(projectId);

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/mysql/externalDb`,
        dataForSave,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_SAVE_MY_SQL_DATA_IN_EXTERNAL_DB_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_SAVE_MY_SQL_DATA_IN_EXTERNAL_DB_FAILURE,
            data: { error: err },
          });
          const { response } = err;
          if (response.status === 400) {
            const { error } = response.data ? response.data : '';
            toast.error(`${error} !`);
          } else {
            console.log('🚀 ~ saveMySqlDataInExternalDb ~ error:', err);
          }
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSaveMySqlDataInExternalDbError() {
  return {
    type: DATA_CONNECTOR_SAVE_MY_SQL_DATA_IN_EXTERNAL_DB_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_SAVE_MY_SQL_DATA_IN_EXTERNAL_DB_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        saveMySqlDataInExternalDbPending: true,
        saveMySqlDataInExternalDbError: null,
      };

    case DATA_CONNECTOR_SAVE_MY_SQL_DATA_IN_EXTERNAL_DB_SUCCESS:
      // The request is success
      return {
        ...state,
        saveMySqlDataInExternalDbPending: false,
        saveMySqlDataInExternalDbError: null,
        mysqlExternalData: action.data,
      };

    case DATA_CONNECTOR_SAVE_MY_SQL_DATA_IN_EXTERNAL_DB_FAILURE:
      // The request is failed
      return {
        ...state,
        saveMySqlDataInExternalDbPending: false,
        saveMySqlDataInExternalDbError: action.data.error,
      };

    case DATA_CONNECTOR_SAVE_MY_SQL_DATA_IN_EXTERNAL_DB_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        saveMySqlDataInExternalDbError: null,
      };

    default:
      return state;
  }
}
